/* Céla — Mur d'avis. Les avis viennent de Judge.me (lecture publique).
   Avis importés : jamais de prénom (les noms fournis à l'import ne sont pas ceux des vraies acheteuses),
   seulement la mention « Avis importé ». La note et la répartition comptent tous les avis. */
(function () {
  var PATH = 'M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z';
  var SVG = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + PATH + '"/></svg>';
  var SVG_OFF = '<svg viewBox="0 0 20 20" aria-hidden="true" class="off"><path d="' + PATH + '"/></svg>';

  function fr(n) { return (Math.round(n * 10) / 10).toFixed(1).replace('.', ','); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function txt(html) {
    var d = new DOMParser().parseFromString('<div>' + (html || '') + '</div>', 'text/html');
    return (d.body.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function stars(n) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += i <= n ? SVG : SVG_OFF;
    return '<span class="cav-stars" role="img" aria-label="' + n + ' sur 5">' + s + '</span>';
  }
  function avgStars(avg) {
    var row = SVG + SVG + SVG + SVG + SVG;
    var pct = Math.max(0, Math.min(100, (avg / 5) * 100));
    return '<span class="cav-avgstars" role="img" aria-label="' + fr(avg) + ' sur 5"><span class="cav-avgstars__bg">' + row +
      '</span><span class="cav-avgstars__fg" style="width:' + pct + '%">' + row + '</span></span>';
  }
  function shortName(n) {
    var p = String(n || '').trim().split(/\s+/);
    if (!p[0]) return '';
    return p.length > 1 ? p[0] + ' ' + p[p.length - 1].charAt(0).toUpperCase() + '.' : p[0];
  }

  function init(box) {
    if (box.getAttribute('data-ready')) return;
    box.setAttribute('data-ready', '1');
    var MODE = box.getAttribute('data-mode') || 'tous';
    var FIRST = Number(box.getAttribute('data-first')) || 6;
    var STEP = Number(box.getAttribute('data-step')) || 6;
    var LABEL = box.getAttribute('data-label') || 'Avis importé';
    var base = 'https://cdn.judge.me/reviews/reviews_for_widget?product_id=' + box.getAttribute('data-product') +
      '&per_page=100&sort_by=pictures_first&sort_dir=desc&widget_theme=standard&platform=shopify&shop_domain=' +
      encodeURIComponent(box.getAttribute('data-shop')) + '&ts=' + Math.floor(Date.now() / 3600000);
    var $ = function (s) { return box.querySelector(s); };
    var raw = [], meta = null;

    function load(p) {
      return fetch(base + '&page=' + p).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        if (!d) return;
        if (!meta) meta = d;
        raw = raw.concat(d.reviews || []);
        var tp = (d.pagination && d.pagination.total_pages) || 1;
        if (p < tp && p < 8) return load(p + 1);
      });
    }

    load(1).then(function () { if (meta) build(); }).catch(function () {});

    function build() {
      var seen = {};
      var all = raw.map(function (r) {
        var body = txt(r.body_html), title = txt(r.title);
        var imp = (r.transparency_badges || []).indexOf('review_collected_from_another_provider') !== -1;
        var pics = (r.pictures_urls || []).map(function (u) {
          return { t: u.compact || u.small || u.original, b: u.huge || u.original || u.small };
        }).filter(function (u) { return u.t; });
        return {
          rating: Math.max(1, Math.min(5, Math.round(Number(r.rating) || 0))),
          title: title && title.toLowerCase() !== body.toLowerCase() ? title : '',
          body: body, pics: pics, imported: imp,
          name: imp ? '' : shortName(r.reviewer_name), verified: !imp && !!r.verified_buyer
        };
      }).filter(function (r) {
        if (!r.body && !r.pics.length) return false;
        if (/ali\s?express|\bali\b/i.test(r.body + ' ' + r.title)) return false;
        var k = r.rating + '|' + r.body.toLowerCase();
        if (r.body && seen[k] && !r.pics.length) return false;
        seen[k] = 1;
        r.score = Math.min(r.body.length, 240) / 80;
        return true;
      });
      if (MODE === 'meilleurs') {
        all = all.filter(function (r) { return r.rating >= 4 && (r.body.length >= 15 || r.pics.length); });
      }

      // Résumé (tous les avis, toujours)
      var avg = Number(meta.average_rating) || 0, total = Number(meta.number_of_reviews) || 0;
      $('[data-cav-avg]').innerHTML = esc(fr(avg)) + '<small> / 5</small>';
      $('[data-cav-stars]').innerHTML = avgStars(avg);
      $('[data-cav-count]').innerHTML = 'Note moyenne sur <b>' + total + ' avis</b>';
      var hist = (meta.histogram || []).slice().sort(function (a, b) { return b.rating - a.rating; });
      var tag = MODE === 'tous' ? 'button' : 'div';
      $('[data-cav-bars]').innerHTML = hist.map(function (h) {
        var pct = total ? Math.round((h.frequency / total) * 100) : 0;
        return '<' + tag + (tag === 'button' ? ' type="button" aria-pressed="false"' : '') + ' class="cav__bar" data-r="' + h.rating + '">' +
          '<span class="cav__bar-l">' + h.rating + ' ' + SVG + '</span>' +
          '<span class="cav__bar-t"><span class="cav__bar-f" style="width:' + pct + '%"></span></span>' +
          '<span class="cav__bar-n">' + h.frequency + '</span></' + tag + '>';
      }).join('');
      updateRatingLinks(total);

      // État
      var state = { star: 0, photos: false, sort: 'meilleures', shown: FIRST };
      function filtered() {
        var l = all.filter(function (r) {
          if (state.star && r.rating !== state.star) return false;
          if (state.photos && !r.pics.length) return false;
          return true;
        });
        l.sort(function (a, b) {
          var ph = (b.pics.length ? 1 : 0) - (a.pics.length ? 1 : 0);
          if (state.sort === 'moins') return a.rating - b.rating || b.score - a.score;
          /* « Avec photos d'abord » : les avis avec photos, puis par note, puis les plus détaillés */
          if (state.sort === 'photos') return ph || b.rating - a.rating || b.score - a.score;
          /* Par défaut : de la meilleure à la moins bonne note (avec photos, puis les plus détaillés) */
          return b.rating - a.rating || ph || b.score - a.score;
        });
        return l;
      }

      // Photos des acheteurs
      var photos = [];
      all.slice().sort(function (a, b) { return b.rating - a.rating || b.score - a.score; }).forEach(function (r) {
        r.pics.forEach(function (p, j) { photos.push({ r: r, p: p, j: j }); });
      });
      if (photos.length) {
        var strip = $('[data-cav-strip]');
        strip.innerHTML = photos.slice(0, 30).map(function (o, i) {
          return '<button type="button" class="cav__ph" data-ph="' + i + '" aria-label="Voir la photo ' + (i + 1) + '">' +
            '<img src="' + esc(o.p.t) + '" alt="Photo envoyée avec un avis ' + o.r.rating + ' étoiles" loading="lazy" decoding="async"></button>';
        }).join('');
        $('[data-cav-photos]').hidden = false;
        strip.addEventListener('click', function (e) {
          var b = e.target.closest('[data-ph]');
          if (b) openLb(photos, Number(b.getAttribute('data-ph')));
        });
        /* Le doigt ou la souris arrive sur une photo : on commence à charger la grande version */
        var stripEarly = function (e) {
          var b = e.target.closest('[data-ph]');
          var o = b && photos[Number(b.getAttribute('data-ph'))];
          if (o) lbLoad(o.p.b);
        };
        strip.addEventListener('pointerover', stripEarly);
        strip.addEventListener('pointerdown', stripEarly);
      }

      // Filtres (fiche produit)
      var tools = $('[data-cav-tools]');
      if (MODE === 'tous' && tools) {
        var nPh = all.filter(function (r) { return r.pics.length; }).length;
        tools.querySelector('[data-cav-photo-n]').textContent = '(' + nPh + ')';
        tools.hidden = false;
        tools.addEventListener('click', function (e) {
          var c = e.target.closest('[data-f]');
          if (!c) return;
          var f = c.getAttribute('data-f');
          if (f === 'tous') { state.star = 0; state.photos = false; }
          if (f === 'photos') state.photos = !state.photos;
          state.shown = FIRST; draw();
        });
        tools.querySelector('select').addEventListener('change', function (e) { state.sort = e.target.value; state.shown = FIRST; draw(); });
        $('[data-cav-bars]').addEventListener('click', function (e) {
          var b = e.target.closest('[data-r]');
          if (!b) return;
          var r = Number(b.getAttribute('data-r'));
          state.star = state.star === r ? 0 : r; state.shown = FIRST; draw();
          tools.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      var more = $('[data-cav-more]');
      more.addEventListener('click', function () { state.shown += STEP; draw(); });

      var grid = $('[data-cav-grid]');
      var current = [];
      var gridEarly = function (e) {
        var ph = e.target.closest('[data-cp]');
        if (!ph) return;
        var r = current[Number(ph.closest('[data-k]').getAttribute('data-k'))];
        var p = r && r.pics[Number(ph.getAttribute('data-cp'))];
        if (p) lbLoad(p.b);
      };
      grid.addEventListener('pointerover', gridEarly);
      grid.addEventListener('pointerdown', gridEarly);
      grid.addEventListener('click', function (e) {
        var ph = e.target.closest('[data-cp]');
        if (ph) {
          var card = ph.closest('[data-k]');
          var r = current[Number(card.getAttribute('data-k'))];
          openLb(r.pics.map(function (p, j) { return { r: r, p: p, j: j }; }), Number(ph.getAttribute('data-cp')));
          return;
        }
        var lire = e.target.closest('.cav-card__lire');
        if (lire) {
          var c = lire.closest('.cav-card');
          var open = c.classList.toggle('is-open');
          lire.textContent = open ? 'Réduire' : 'Lire la suite';
        }
      });

      function card(r, k) {
        var who = r.imported
          ? '<span class="cav-tag">' + esc(LABEL) + '</span>'
          : (r.name ? esc(r.name) : 'Cliente') + (r.verified ? ' <span class="cav-tag cav-tag--ok">Achat vérifié</span>' : '');
        return '<article class="cav-card" data-k="' + k + '">' + stars(r.rating) +
          (r.title ? '<p class="cav-card__title">' + esc(r.title) + '</p>' : '') +
          (r.body ? '<p class="cav-card__txt">' + esc(r.body) + '</p><button type="button" class="cav-card__lire" hidden>Lire la suite</button>' : '') +
          (r.pics.length ? '<div class="cav-card__pics">' + r.pics.slice(0, 4).map(function (p, j) {
            return '<button type="button" class="cav-card__ph" data-cp="' + j + '" aria-label="Agrandir la photo"><img src="' + esc(p.t) + '" alt="" loading="lazy" decoding="async"></button>';
          }).join('') + '</div>' : '') +
          '<p class="cav-card__who">' + who + '</p></article>';
      }

      function draw() {
        current = filtered();
        var part = current.slice(0, state.shown);
        grid.innerHTML = part.length ? part.map(card).join('') : '<p class="cav__empty">Aucun avis pour ce choix.</p>';
        more.hidden = current.length <= state.shown;
        if (tools && MODE === 'tous') {
          tools.querySelector('[data-f="tous"]').setAttribute('aria-pressed', String(!state.star && !state.photos));
          tools.querySelector('[data-f="photos"]').setAttribute('aria-pressed', String(state.photos));
          box.querySelectorAll('button.cav__bar').forEach(function (b) {
            b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-r')) === state.star));
          });
          var sh = tools.querySelector('[data-cav-shown]');
          if (sh) sh.textContent = current.length + ' avis' + (state.star ? ' à ' + state.star + ' étoile' + (state.star > 1 ? 's' : '') : '') + (state.photos ? ' avec photos' : '');
        }
        requestAnimationFrame(function () {
          grid.querySelectorAll('.cav-card').forEach(function (c) {
            var t = c.querySelector('.cav-card__txt'), b = c.querySelector('.cav-card__lire');
            if (t && b && t.scrollHeight > t.clientHeight + 2) b.hidden = false;
          });
        });
      }
      draw();
    }

    // Visionneuse
    var lb = null, lbList = [], lbI = 0;
    /* Grandes photos préparées à l'avance (la photo ouverte et ses voisines) */
    var lbPre = {}, lbTok = 0;
    function lbLoad(u) {
      if (!u) return null;
      if (!lbPre[u]) { var im = new Image(); im.decoding = 'async'; im.src = u; lbPre[u] = im; }
      return lbPre[u];
    }
    function openLb(list, i) {
      lbList = list; lbI = i;
      if (!lb) {
        lb = document.createElement('dialog');
        lb.className = 'cav-lb';
        lb.setAttribute('aria-label', 'Photo d’un avis');
        lb.innerHTML = '<div class="cav-lb__in"><div class="cav-lb__media"><img alt="">' +
          '<button type="button" class="cav-lb__nav cav-lb__nav--prev" aria-label="Photo précédente">‹</button>' +
          '<button type="button" class="cav-lb__nav cav-lb__nav--next" aria-label="Photo suivante">›</button></div>' +
          '<div class="cav-lb__info"></div></div><button type="button" class="cav-lb__close" aria-label="Fermer">×</button>';
        document.body.appendChild(lb);
        lb.querySelector('.cav-lb__close').addEventListener('click', function () { lb.close(); });
        lb.querySelector('.cav-lb__nav--prev').addEventListener('click', function () { show(lbI - 1); });
        lb.querySelector('.cav-lb__nav--next').addEventListener('click', function () { show(lbI + 1); });
        lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
        lb.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') show(lbI - 1);
          if (e.key === 'ArrowRight') show(lbI + 1);
        });
      }
      show(i);
      if (!lb.open) lb.showModal();
    }
    function show(i) {
      var n = lbList.length;
      lbI = (i + n) % n;
      var o = lbList[lbI], r = o.r;
      var img = lb.querySelector('.cav-lb__media img'), big = lbLoad(o.p.b), my = ++lbTok;
      if (!big || (big.complete && big.naturalWidth > 0) || o.p.t === o.p.b) {
        img.src = o.p.b;
      } else {
        /* La petite photo (déjà chargée) s'affiche tout de suite, la grande la remplace dès qu'elle est prête */
        img.src = o.p.t;
        var put = function () { if (my === lbTok) img.src = o.p.b; };
        if (big.decode) big.decode().then(put, function () {});
        else big.onload = put;
      }
      if (n > 1) { lbLoad(lbList[(lbI + 1) % n].p.b); lbLoad(lbList[(lbI - 1 + n) % n].p.b); }
      lb.querySelector('.cav-lb__media img').alt = 'Photo envoyée avec un avis ' + r.rating + ' étoiles';
      lb.querySelectorAll('.cav-lb__nav').forEach(function (b) { b.hidden = n < 2; });
      lb.querySelector('.cav-lb__info').innerHTML = stars(r.rating) +
        (r.title ? '<p><b>' + esc(r.title) + '</b></p>' : '') + (r.body ? '<p>' + esc(r.body) + '</p>' : '') +
        '<p class="cav-card__who">' + (r.imported ? '<span class="cav-tag">' + esc(LABEL) + '</span>' : esc(r.name || 'Cliente')) + '</p>' +
        (n > 1 ? '<span class="cav-lb__pos">Photo ' + (lbI + 1) + ' sur ' + n + '</span>' : '');
    }

    // « 4,5/5 » à côté du titre du produit : on ajoute « · x avis », qui descend jusqu'au mur
    function updateRatingLinks(total) {
      if (!total) return;
      document.querySelectorAll('.cm-produit__rating').forEach(function (el) {
        if (el.querySelector('.cav-ratinglink')) return;
        var a = document.createElement('a');
        a.className = 'cav-ratinglink';
        a.href = '#' + box.id;
        a.textContent = total + ' avis';
        a.addEventListener('click', function (e) { e.preventDefault(); box.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        el.appendChild(document.createTextNode(' · '));
        el.appendChild(a);
      });
    }
  }

  function boot() { document.querySelectorAll('[data-cav]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();